import React from 'react';
import PageNavigator from './PageNavigator';
import styles from './InstallmentTable.module.css';

const InstallmentTable = ({ installments, title, onClose, loading, currentPage = 1, totalPages = 1, onPageChange }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-EG', {
            style: 'currency',
            currency: 'EGP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };


    return (
        <div className={styles.fullTableContainer}>
            <div className={styles.tableHeader}>
                <div className={styles.tableHeaderLeft}>
                    <button className={styles.backToProfileButton} onClick={onClose}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5" />
                            <path d="M12 19l-7-7 7-7" />
                        </svg>
                        Back to Profile
                    </button>
                    <h3 className={styles.tableTitle}>{title}</h3>
                </div>
            </div>
            <div className={styles.installmentTableContent}>
                <div className={styles.tableContainer}>
                    <table className={styles.installmentTable}>
                        <thead>
                            <tr>
                                <th className={styles.installmentColumn}>Installment #</th>
                                <th className={styles.unitColumn}>Unit</th>
                                <th className={styles.amountColumn}>Amount</th>
                                <th className={styles.dateColumn}>Date</th>
                                <th className={styles.statusColumn}>Status</th>
                                <th className={styles.categoryColumn}>Category</th>
                                <th className={styles.methodColumn}>Payment Method</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={7} className={styles.loadingRow}>
                                        <span className={styles.spinner} /> Loading installments...
                                    </td>
                                </tr>
                            ) : installments.length > 0 ? (
                                installments.map((installment, index) => (
                                    <tr key={installment.id || index} className={styles.tableRow}>
                                        <td className={styles.installmentColumn}>
                                            <span className={styles.installmentNumber}>{index + 1 + (currentPage - 1) * 16}</span>
                                        </td>
                                        <td className={styles.unitColumn}>
                                            <span className={styles.unitValue}>{installment.unit_label || '-'}</span>
                                        </td>
                                        <td className={styles.amountColumn}>
                                            <span className={styles.amountValue}>{formatCurrency(installment.amount)}</span>
                                        </td>
                                        <td className={styles.dateColumn}>
                                            <span className={styles.dateValue}>{installment.date}</span>
                                        </td>
                                        <td className={styles.statusColumn}>
                                            <span className={`${styles.statusBadge} ${styles[installment.status.toLowerCase()]}`}>
                                                {installment.status === 'paid' ? 'Paid' : 'Not Paid'}
                                            </span>
                                        </td>
                                        <td className={styles.categoryColumn}>
                                            {installment.category && (
                                                <span className={`${styles.categoryBadge} ${styles[installment.category.toLowerCase()]}`}>
                                                    {installment.category}
                                                </span>
                                            )}
                                        </td>
                                        <td className={styles.methodColumn}>
                                            <span className={styles.methodValue}>{installment.payment_method || '-'}</span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7} className={styles.noData}>
                                        No {title.toLowerCase()} found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <div className={styles.tableFooter}>
                        <PageNavigator
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={onPageChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default InstallmentTable; 